module.exports = __webpack_public_path__ + "static/plane-4107759080ad714bcb18bf50f1cdf932.svg";